import { wrapTo, toggleSidePanel, onLayerClick, reorderLayer, layerVisualChannelConfigChange, setFilter, addFilter, updateMap, layerVisConfigChange } from 'kepler.gl/actions';
import { ActionTypes } from "kepler.gl/actions";
import { reverseTransformSingleTraffic, reverseTransformSingleMunicipal, reverseTransformSingleRoadSign } from "./../helpers/fieldTransformer";
import { areListsEqual } from "./../utils/listUtils";
import { initialAnimation } from '../animations/Animation';
import { FlyToInterpolator } from 'deck.gl';

// Declare the variable outside so it persists between actions
let lastClickTime = 0;
let isFilterSet = false;
let previousZoom = 0;
const NumberOfLayers = 12;

export const reduxkMiddleware = store => next => async action => {
    console.log('Action :', action); // TODO : Remove comments after testing

    if (action.type === 'STORE_TRANSFORMED_EVIDENCE_DATA') {
        store.dispatch(wrapTo('evidence', toggleSidePanel()));
    }

    let previousLayeredTrafficInfractionData = [];
    if (
        store.getState().keplerGl &&
        store.getState().keplerGl.evidence &&
        store.getState().keplerGl.evidence.visState &&
        store.getState().keplerGl.evidence.visState.layers.length !== 0 &&
        store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs") >= 0
    ) {

        const trafficInfractionLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs");

        previousLayeredTrafficInfractionData =
        store.getState().keplerGl.evidence.visState.layerData[trafficInfractionLayerIndex].data;
    }

    let previousLayeredMunicipalInfractionData = [];
    if (
        store.getState().keplerGl &&
        store.getState().keplerGl.evidence &&
        store.getState().keplerGl.evidence.visState &&
        store.getState().keplerGl.evidence.visState.layers.length !== 0 &&
        store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds") >= 0
    ) {

        const municiaplInfractionLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds");

        previousLayeredMunicipalInfractionData =
        store.getState().keplerGl.evidence.visState.layerData[municiaplInfractionLayerIndex].data;
    }

    if (
        action.type === ActionTypes.LAYER_CLICK &&
        action.payload.info &&
        action.payload.info.object &&
        action.payload.info.object.index
    ) {
        const now = Date.now();

        if (lastClickTime && (now - lastClickTime) < 500) {
            // Double-click detected within 500ms
            lastClickTime = 0; // Reset the timestamp
            console.log('LAYER_CLICK Double click detected');

            let selectedPointData;
            let transformedData;

            switch (action.payload.info.layer.id) {
                case 'h5kymjs':
                    selectedPointData = store.getState().data.evidenceData.rows[action.payload.info.object.index];
                    transformedData  = reverseTransformSingleTraffic(selectedPointData);
                    break;
                case 'h5kymds':
                    selectedPointData = store.getState().data.municipalData.rows[action.payload.info.object.index];
                    transformedData  = reverseTransformSingleMunicipal(selectedPointData);
                    break;
                case 'i5kyees':
                    selectedPointData = store.getState().data.roadSignData.rows[action.payload.info.object.index];
                    transformedData  = reverseTransformSingleRoadSign(selectedPointData);
                    break;
            }

            store.dispatch({type: 'INFRACTION_SELECTED', payload: { ... transformedData, isDoubledClickedOnInfraction: true }});

            await sleep(1000);

            store.dispatch(wrapTo('evidence', updateMap({latitude: transformedData.latitude, longitude: (transformedData.longitude * 0.99997), zoom: 16.5, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));

            store.dispatch({ type: 'TOGGLE_OFF_VIDEO_SECTION', payload: false });

        } else {
            // Not a double-click; record this click's timestamp.
            lastClickTime = now;
            setTimeout(() => {
                // After 500ms, if no further click resets it, then clear it.
                if (Date.now() - lastClickTime >= 500) {
                lastClickTime = 0;
                }
            }, 500);
        }
    } else if (
        (action.type === ActionTypes.LAYER_CLICK &&
        action.payload.info &&
        !action.payload.info.object) ||
        (action.type === ActionTypes.LAYER_CLICK &&
        action.payload.info &&
        action.payload.info.object)
    ) {
        store.dispatch({
        type: 'TOGGLE_OFF_VIDEO_SECTION',
        payload: true
        });
    }
    // Pass the action along to the next middleware/reducer
    const result = next(action);

    if (action.type === ActionTypes.UPDATE_MAP && action.payload && action.payload.payload && action.payload.payload.zoom && Math.abs(previousZoom - action.payload.payload.zoom) > 0.5 && store.getState().keplerGl.evidence.visState.layers.length == NumberOfLayers) {
        let trafficInfractionLayerIndex;
        let municipalInfractionLayerIndex;
        let roadSignLayerIndex;

        store.getState().keplerGl.evidence.visState.layers.map((layer, index) => {
            if (layer.config.dataId == 'evidence') {
                trafficInfractionLayerIndex = index;
            } else if (layer.config.dataId == 'municipal') {
                municipalInfractionLayerIndex = index;
            } else if (layer.config.dataId == 'roadsign') {
                roadSignLayerIndex = index;
            }
        });

        const zoomMin = 14;
        const zoomMax = 19;
        const radiusMin = 1;
        const radiusMax = 15;
        // Clamp zoom within the range [8, 20]
        const zoom = Math.max(Math.min(action.payload.payload.zoom, zoomMax), zoomMin);
        const desiredRadius = radiusMax - ((zoom - zoomMin) * (radiusMax - radiusMin)) / (zoomMax - zoomMin);

        store.dispatch(wrapTo('evidence', layerVisConfigChange(
            store.getState().keplerGl.evidence.visState.layers[trafficInfractionLayerIndex], 
        {
            radius : desiredRadius
        })));
        store.dispatch(wrapTo('evidence', layerVisConfigChange(
            store.getState().keplerGl.evidence.visState.layers[municipalInfractionLayerIndex], 
        {
            radius : desiredRadius
        })));
        store.dispatch(wrapTo('evidence', layerVisConfigChange(
            store.getState().keplerGl.evidence.visState.layers[roadSignLayerIndex], 
        {
            radius : desiredRadius
        })));

        previousZoom = action.payload.payload.zoom;
    }

    if (action.type === ActionTypes.ADD_DATA_TO_MAP && 
        action.payload && action.payload.datasets && 
        action.payload.datasets[0].info && 
        action.payload.datasets[0].info.id &&
        store.getState().keplerGl.evidence.visState.layers.length == NumberOfLayers
    ) {

        const requiredLayerOrder = {
            "evidence": 0,
            "municipal": 1,
            "roadsign":2,
            "ward": 3,
            "zone": 4,
            "mp": 5,
            "ac": 6,
            "police": 7,
            "trafficpolice": 8,
            "routecoverage": 9,
            "segmentscore": 10,
            "segmentheatmapscore": 11
        }

        const updatedLayers = store.getState().keplerGl.evidence.visState.layers;

        const updatedReorderLayer = [];

        let wardLayerIndex;
        let trafficInfractionLayerIndex;
        let municipalInfractionLayerIndex;
        let roadSignLayerIndex;
        let zoneLayerIndex;
        let mpLayerIndex;
        let acLayerIndex;
        let policeLayerIndex;
        let trafficPoliceLayerIndex;
        let routeCoverageLayerIndex;
        let segmentScoreLayerIndex;
        let segmentHeatmapScoreLayerIndex;

        updatedLayers.map((layer, index) => {
            updatedReorderLayer[requiredLayerOrder[layer.config.dataId]] = index;
            if (layer.config.dataId == 'ward') {
                wardLayerIndex = index;
            } else if (layer.config.dataId == 'evidence') {
                trafficInfractionLayerIndex = index;
            } else if (layer.config.dataId == 'municipal') {
                municipalInfractionLayerIndex = index;
            } else if (layer.config.dataId == 'roadsign') {
                roadSignLayerIndex = index;
            } else if (layer.config.dataId == 'zone') {
                zoneLayerIndex = index
            } else if (layer.config.dataId == 'mp') {
                mpLayerIndex = index
            } else if (layer.config.dataId == 'ac') {
                acLayerIndex = index
            } else if (layer.config.dataId == 'police') {
                policeLayerIndex = index
            } else if (layer.config.dataId == 'trafficpolice') {
                trafficPoliceLayerIndex = index
            } else if (layer.config.dataId == 'routecoverage') {
                routeCoverageLayerIndex = index
            }  else if (layer.config.dataId == 'segmentscore') {
                segmentScoreLayerIndex = index
            } else if (layer.config.dataId == 'segmentheatmapscore') {
                segmentHeatmapScoreLayerIndex = index
            }
        });

        console.log("Sujeet logs updatedReorderLayer", updatedReorderLayer);

        store.dispatch(wrapTo('evidence', reorderLayer(updatedReorderLayer)));

        // Just set only one because this reorder layer will run in every infraction list update.
        if (!isFilterSet) {
            store.dispatch(wrapTo('evidence', addFilter("evidence")));
            store.dispatch(wrapTo('evidence', addFilter("municipal")));
            store.dispatch(wrapTo('evidence', addFilter("roadsign")));
            store.dispatch(wrapTo('evidence', addFilter("ward")));
            store.dispatch(wrapTo('evidence', addFilter("zone")));
            store.dispatch(wrapTo('evidence', addFilter("mp")));
            store.dispatch(wrapTo('evidence', addFilter("ac")));
            store.dispatch(wrapTo('evidence', addFilter("police")));
            store.dispatch(wrapTo('evidence', addFilter("trafficpolice")));
            store.dispatch(wrapTo('evidence', addFilter("segmentscore")));
            store.dispatch(wrapTo('evidence', addFilter("segmentheatmapscore")));
            store.dispatch(wrapTo('evidence', setFilter(0, "dataId","evidence", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(1, "dataId","municipal", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(2, "dataId","roadsign", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(3, "dataId","ward", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(4, "dataId","zone", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(5, "dataId","mp", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(6, "dataId","ac", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(7, "dataId","police", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(8, "dataId","trafficpolice", undefined)));

            store.dispatch(wrapTo('evidence', setFilter(0, "name","Infraction Type", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(1, "name","Infraction Type", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(2, "name","Road Sign Type", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(3, "name","Name", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(4, "name","Zone", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(5, "name","Constituency Name", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(6, "name","Constituency Name", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(7, "name","Station Name", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(8, "name","Station Name", undefined)));
            isFilterSet = true;

            store.dispatch({ type: 'TOGGLE_SHOW_DROP_DOWN_FILTERS', payload: true });

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[wardLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.ward.fields[21]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[acLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.ac.fields[11]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[mpLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.mp.fields[10]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[policeLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.police.fields[11]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[trafficPoliceLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.trafficpolice.fields[12]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[zoneLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.zone.fields[5]
            },
            'color')));
    
            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[trafficInfractionLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.evidence.fields[0]
            },
            'color')));
    
            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[municipalInfractionLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.municipal.fields[4]
            },
            'color')));
    
            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[roadSignLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.roadsign.fields[4]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[segmentScoreLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.segmentscore.fields[2]
            },
            'color')));

            // store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
            //     store.getState().keplerGl.evidence.visState.layers[segmentHeatmapScoreLayerIndex], 
            // {
            //     colorField : store.getState().keplerGl.evidence.visState.datasets.segmentheatmapscore.fields[2]
            // },
            // 'color')));


            initialAnimation(store);

        } else {

            store.dispatch(wrapTo('evidence', addFilter("ward")));
            store.dispatch(wrapTo('evidence', setFilter(3, "dataId","ward", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(3, "name","Name", undefined)));

            store.dispatch(wrapTo('evidence', addFilter("zone")));
            store.dispatch(wrapTo('evidence', setFilter(4, "dataId","zone", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(4, "name","Zone", undefined)));

            store.dispatch(wrapTo('evidence', addFilter("mp")));
            store.dispatch(wrapTo('evidence', setFilter(5, "dataId","mp", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(5, "name","Constituency Name", undefined)));

            store.dispatch(wrapTo('evidence', addFilter("ac")));
            store.dispatch(wrapTo('evidence', setFilter(6, "dataId","ac", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(6, "name","Constituency Name", undefined)));

            store.dispatch(wrapTo('evidence', addFilter("police")));
            store.dispatch(wrapTo('evidence', setFilter(7, "dataId","police", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(7, "name","Station Name", undefined)));

            store.dispatch(wrapTo('evidence', addFilter("trafficpolice")));
            store.dispatch(wrapTo('evidence', setFilter(8, "dataId","trafficpolice", undefined)));
            store.dispatch(wrapTo('evidence', setFilter(8, "name","Station Name", undefined)));

            store.dispatch({ type: 'SHOW_WARD_DROPDOWN', payload: Date.now()});

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[wardLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.ward.fields[21]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[acLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.ac.fields[11]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[mpLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.mp.fields[10]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[policeLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.police.fields[11]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[trafficPoliceLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.trafficpolice.fields[12]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[zoneLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.zone.fields[5]
            },
            'color')));

            store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
                store.getState().keplerGl.evidence.visState.layers[segmentScoreLayerIndex], 
            {
                colorField : store.getState().keplerGl.evidence.visState.datasets.segmentscore.fields[2]
            },
            'color')));

            // store.dispatch(wrapTo('evidence', layerVisualChannelConfigChange(
            //     store.getState().keplerGl.evidence.visState.layers[segmentHeatmapScoreLayerIndex], 
            // {
            //     colorField : store.getState().keplerGl.evidence.visState.datasets.segmentheatmapscore.fields[2]
            // },
            // 'color')));

        }
    }

    if (
        action.type === ActionTypes.LAYER_CLICK &&
        action.payload.info &&
        action.payload.info.object
    ) {
        store.dispatch(wrapTo('evidence', onLayerClick(null)));
    }

    let newLayeredTrafficInfractionData = [];
    if (
        store.getState().keplerGl &&
        store.getState().keplerGl.evidence &&
        store.getState().keplerGl.evidence.visState &&
        store.getState().keplerGl.evidence.visState.layers.length !== 0 &&
        store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs") >= 0
    ) {
        const trafficInfractionLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs");

        newLayeredTrafficInfractionData =
        store.getState().keplerGl.evidence.visState.layerData[trafficInfractionLayerIndex].data;
    }

    let newLayeredMunicipalInfractionData = [];
    if (
        store.getState().keplerGl &&
        store.getState().keplerGl.evidence &&
        store.getState().keplerGl.evidence.visState &&
        store.getState().keplerGl.evidence.visState.layers.length !== 0 &&
        store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds") >= 0
    ) {
        const municipalInfractionLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds");

        newLayeredMunicipalInfractionData =
        store.getState().keplerGl.evidence.visState.layerData[municipalInfractionLayerIndex].data;
    }

    if (!areListsEqual(previousLayeredTrafficInfractionData, newLayeredTrafficInfractionData)) {
        // List has changed—handle accordingly.
        store.dispatch({ type: 'TRAFFIC_INFRACTION_LIST_UPDATED', payload: newLayeredTrafficInfractionData});
    }

    if (!areListsEqual(previousLayeredMunicipalInfractionData, newLayeredMunicipalInfractionData)) {
        // List has changed—handle accordingly.
        store.dispatch({ type: 'MUNICIPAL_INFRACTION_LIST_UPDATED', payload: newLayeredMunicipalInfractionData});
    }

    return result;
};

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
